import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";

import { IconRemainingVacations } from "../../common/icons";
import { LoadingContainer } from "../../common/loaders/loadingcontainer";
import { useGetCurrentUserPerson } from "../../api/endpoints";
import { vacationBalancesYearlyGetPerson } from "../../api";

export function PersonalRemainingVacationDays() {
  const { t } = useTranslation();

  const { data: user, isLoading: userLoading } = useGetCurrentUserPerson();
  const personId = user?.personId;

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!personId) return;

    let active = true;

    const load = async () => {
      try {
        setLoading(true);

        const res = await vacationBalancesYearlyGetPerson(personId);
        const list = res?.data ?? [];

        if (!active) return;

        setData(list);
      } finally {
        if (active) setLoading(false);
      }
    };

    load();

    return () => {
      active = false;
    };
  }, [personId]);

  if (userLoading || loading || !personId) {
    return <LoadingContainer />;
  }

  const remaining = data.reduce(
    (sum, x) =>
      sum + Math.max(
        0,
        Number(x.vacationAllowanceDays ?? 0) -
        Number(x.usedVacationDays ?? 0)
      ),
    0
  );

  return (
    <>
      <h4 style={{ color: "var(--heeros-blue)" }}>
        {t("RemainingVacationDays", "Lomasaldo")}
      </h4>

      <Row className="text-center mt-4-5">
        <Col>
          <IconRemainingVacations />
          <div className="vacation-label">
            {t("RemainingVacationDays", "Lomapäiviä jäljellä")}
          </div>
          <h2 className="vacation-value">{remaining}</h2>
        </Col>
      </Row>
    </>
  );
}